import { Component, input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'r2e-label',
  template: '<ng-content />',
  styleUrls: ['./label.component.scss'],
  host: { '[class]': 'color()' }
})
export class LabelComponent {
  color = input<ThemePalette | 'success'>();
}
